import React from 'react';

function ProjectInfo() {
  return (
    <div style={{ padding: 20 }}>
      <div>Version: 0.0.2</div>
    </div>
  );
}

export default ProjectInfo;
